<script lang="ts">
const Layout = defineComponent({
  name: 'Layout',
  props: {
    layout: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    return () => {
      return h(layouts[props.layout]!, context.attrs, context.slots);
    };
  },
});
</script>

<script setup lang="ts">
import { useHead } from '@vueuse/head';
import layouts from 'virtual:vite-auto-layouts';
import { computed, defineComponent, h } from 'vue';
import { ModalsContainer } from 'vue-final-modal';
import { useRoute } from 'vue-router';

import { useIsMobile } from '@/plugins/is-mobile';

const isMobile = useIsMobile();

const route = useRoute();

useHead(() => ({
  bodyAttrs: {
    class: !isMobile ? 'min-w-[1920px]' : '',
  },
}));

const layout = computed(
  () => (route.meta.layout as keyof typeof layouts) ?? 'default'
);
</script>

<template>
  <Suspense>
    <Layout :layout="layout">
      <RouterView #="{ Component }">
        <template v-if="Component">
          <Suspense>
            <Component :is="Component" />
          </Suspense>
        </template>
      </RouterView>
    </Layout>
  </Suspense>

  <ModalsContainer />


  <footer class="flex h-7.5 items-center justify-between whitespace-nowrap bg-[#1E1E2D] px-7.5 text-[13px] text-[#616366]">
    <span>Confidential © Leishan Co.,Ltd. All rights reserved.</span>
    <span v-if="!isMobile">2025 - Version 1.0.8</span>
  </footer>
</template>

